
<template>
  <div class="lyrics_page">  
     <div class="content" style="font-size:18px;">

      <div class="download_buttons">
        <a v-if="item.press_lyrics > 0" class="btn_down" :href="'https://www.mysong.co.il/download/press/' + item.id + '?type=lyrics'"><i class="material-icons dp48">file_download</i> הורדת מילים</a>
      </div>

<div  v-if="item.songs.length > 1" class="accordion-wrapper">
  <accordion v-for="(song, index) in item.songs" :key="song.id" :data-blat="song.id" @opened="onopened(song.id); $emit('play_song', song.id);" ref="lyrics_item">
    <div slot="header" :class="item.songs[index].left_title == '1' ? 'text-left' : ''" v-text="(index+1) + '. ' + song.name"></div>
    <div v-html="song.lyrics"></div>
  </accordion>
</div>
<div v-else>

  <div class="accordion open nobg">
    <div class="header" :class="item.songs[0].left_title == '1' ? 'text-left' : ''" v-text="item.songs[0].name"></div>
    <div class="body">
      <div class="body-inner"  v-html="item.songs[0].lyrics"></div>
    </div>
  </div>
</div>


     </div>
  </div>
</template>

<script>

import accordion from '../components/accordion.vue'


export default {
  components: {
    accordion
  },
  props: ["widgets", "item"],
  computed: {
      myItems(){

        var list = [];
        for (let i in this.item.songs)
        {
            list.push({
                title: (i+1) + '. ' + this.item.songs[i].name,
                value: this.item.songs[i].lyrics,
                category: 'Tab-1'
            });
        }

        return list;
      }
  },
  methods:{
    onopened(id){
      for (let i in this.$refs.lyrics_item)
      {
        if (id != this.$refs.lyrics_item[i].$el.getAttribute('data-blat')) this.$refs.lyrics_item[i].show = false;
      }
    }
  },
  created(){
    

  }
}
</script>
